export function formatProcedureErrorMessage(errorMessage: string): string {
  if (!errorMessage) {
    return '';
  }

  // Identify the pattern for procedures (e.g., "1234567890 - Procedure Name")
  const procedurePattern = /\b\d{10}\s+-/;
  const hasProcedures = procedurePattern.test(errorMessage);

  //Return the original message if no procedures are found
  if (!hasProcedures) {
    return errorMessage;
  }

  return buildErrorHtml(errorMessage, procedurePattern);
}

function buildErrorHtml(message: string, pattern: RegExp): string {
  const { prefix, procedures, suffix } = parseErrorMessage(message, pattern);

  const prefixHtml = prefix ? `<div class="error-prefix">${prefix}</div>` : '';
  const suffixHtml = suffix ? `<div class="error-suffix">${suffix}</div>` : '';

  //Transoform procedures array into list items
  const listItems = procedures.map((procedure) => `<li>${procedure.trim()}</li>`).join('');

  return `
    <div class="error-formatted-container">
      ${prefixHtml}
      <ul class="error-list">
        ${listItems}
      </ul>
      ${suffixHtml}
    </div>
  `.trim();
}

function parseErrorMessage(message: string, pattern: RegExp) {
  let mainText = message;
  let suffix = '';

  //Capture any text after the last period that starts with a capital letter, assuming it's a suffix
  const suffixMatch = message.match(/\.\s*([A-Z][^.]*\.?)$/);

  if (suffixMatch) {
    suffix = suffixMatch[1];
    mainText = message.substring(0, suffixMatch.index);
  }

  //Find the index of the first procedure pattern to separate the prefix from the procedures list
  const firstProcedureIndex = mainText.search(pattern);
  const prefix = mainText.substring(0, firstProcedureIndex).trim();
  const proceduresContent = mainText.substring(firstProcedureIndex);

  //Split the procedures content into individual procedures using a regex that looks for commas followed by a new procedure pattern
  const procedures = proceduresContent.split(/,\s*(?=\d{10}\s+-)/);

  return {
    prefix,
    procedures,
    suffix,
  };
}
